import request from '@/utils/request'
import axios from 'axios'
import {ADMIN_URL,ADMIN_SERVICE_URL} from "@/utils/constant"
export function getPolicy(params) {
  return request({
    url: `${ADMIN_SERVICE_URL}/oss/policy`,
    method: 'get',
    params
  })
}

export function getStsToken(params) {
  return request({
    url: `${ADMIN_SERVICE_URL}/getcosuploadtoken`,
    method: 'post',
    params:{
      resourceType:1
    }
  })
}

/**
 * 阿里云上传
 * @author yang5chao@aliyun.com
 * @param {String} host
 * @param {FormData} params
 * @date 2020-10-02 14:23
 */
export function uploadAliOss(host, params) {
  return new Promise((resolve, reject) => {
    axios({
      url: host,
      header: {
        'Content-Type': 'multipart/form-data'
      },
      method: 'post',
      data: params
    }).then(() => {
      resolve({
        code: 20000
      })
    }).catch(err => {
      reject(err)
    })
  })
}

